import { Controller } from "@hotwired/stimulus"

// Generic multi-select filter controller for shape, color, clarity, etc.
export default class extends Controller {
  toggle(event) {
    const checkbox = event.target
    const label = checkbox.closest('label')
    
    // Toggle button styling
    if (checkbox.checked) {
      label.classList.remove('btn-outline-primary')
      label.classList.add('btn-primary')
    } else {
      label.classList.remove('btn-primary')
      label.classList.add('btn-outline-primary')
    }
    
    // Submit the form (find the parent form)
    const form = this.element.closest('form')
    if (form) {
      // Trigger the diamonds--filter controller's submitForm if it exists
      const filterController = this.application.getControllerForElementAndIdentifier(form, 'diamonds--filter')
      if (filterController && filterController.submitForm) {
        filterController.submitForm()
      } else {
        // Fallback: submit directly
        form.requestSubmit()
      }
    }
  }
}
